import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import {
 Card,
 CardHeader,
 CardTitle,
 CardContent,
 Toast,
 ToastType,
 ModernButton,
 Button,
} from "../../components/ui";
import { ProposalForm } from "../../components/proposals";
import { ProposalFormData } from "../../types";
import { useProposals } from "../../hooks/useProposals";

export const ProposalCreatePage: React.FC = () => {
 const navigate = useNavigate();
 const [searchParams] = useSearchParams();
 const { createProposal } = useProposals();

 const [isSubmitting, setIsSubmitting] = useState(false);
 const [toast, setToast] = useState<{
 message: string;
 type: ToastType;
 } | null>(null);

 // Parâmetros da URL
 const leadId = searchParams.get("leadId");
 const vehicleId = searchParams.get("vehicleId");

 const handleSubmit = async (data: ProposalFormData) => {
 setIsSubmitting(true);
 try {
 await createProposal(data);
 setToast({
 message: "Proposta criada com sucesso!",
 type: "success",
 });

 // Redirecionar para a lista de propostas após 1 segundo
 setTimeout(() => {
 navigate("/proposals");
 }, 1000);
 } catch (err) {
 console.error("Erro ao criar proposta:", err);
 setToast({
 message: "Erro ao criar proposta. Tente novamente.",
 type: "error",
 });
 } finally {
 setIsSubmitting(false);
 }
 };

 const handleCancel = () => {
 navigate("/proposals");
 };

 return (
 <div className="space-y-6">
 {/* Header */}
 <div className="flex items-center justify-between">
 <div className="flex items-center gap-4">
 <Button
 variant="outline"
 onClick={() => navigate("/proposals")}
 className="flex items-center gap-2"
 >
 <ArrowLeft className="h-4 w-4" />
 Voltar
 </Button>
 <div>
 <h1 className="text-2xl font-bold text-foreground">
 Nova Proposta
 </h1>
 <p className="mt-1 text-sm text-muted-foreground">
 Crie uma nova proposta de negociação para um cliente
 </p>
 </div>
 </div>
 </div>

 {/* Form */}
 <Card>
 <CardHeader>
 <CardTitle>Dados da Proposta</CardTitle>
 </CardHeader>
 <CardContent>
 <ProposalForm
 onSubmit={handleSubmit}
 onCancel={handleCancel}
 isSubmitting={isSubmitting}
 preSelectedLeadId={leadId || undefined}
 preSelectedVehicleId={vehicleId || undefined}
 />
 </CardContent>
 </Card>

 {/* Toast Notifications */}
 {toast && (
 <Toast
 message={toast.message}
 type={toast.type}
 onClose={() => setToast(null)}
 duration={3000}
 />
 )}
 </div>
 );
};
